import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

import FavouriteIconButton from "../../Favourite/IconButton"

/**
 * export styled favourite button
 */
export default styled(FavouriteIconButton)`
  position: absolute;
  top: 0;
  right: 25px;
  padding: ${padding.small} 0;
  z-index: 1;
  outline: none;

  ${minWidthMedia.tablet`
    right: 0;
    padding: ${padding.small} ${padding.tiny};
  `}

  ${minWidthMedia.desktop`
    display: none;
  `}
`
